import {
    USER,
    ROLE,
    EMPLOYEE_PIS,
    CONTROL_CONFIGS,
    REQUIRED_FIELD_CONFIGS,
    DATE_LOCAL_STORAGE,
    POST_LOGOUT_REDIRECTURI,
    TENANT_EMPLOYEE,
    SHOW_LOGIN,
    APP_READONLY
}
    from './storageTypes'
import moment from 'moment'
import encryptStorage from './encryptStorage'

let Storage = {}


Storage.clear = () => {

    let postLogoutUri = encryptStorage.getItem(POST_LOGOUT_REDIRECTURI)
    let showLogin = encryptStorage.getItem(SHOW_LOGIN)

    encryptStorage.clear()
    if(postLogoutUri)
    {
        encryptStorage.setItem(POST_LOGOUT_REDIRECTURI, postLogoutUri)
    }
    if(showLogin)
    {
        encryptStorage.setItem(SHOW_LOGIN, showLogin)
    }
}
/// Get ////
Storage.getUser = () => {
    let result = encryptStorage.getItem(USER)

    if (result)
    {
        return result
    }else{
        return {}
    }
}

Storage.getRole = () => {
    let result = encryptStorage.getItem(ROLE)
    return result
}

Storage.getRoleAdmin = () => {

    let user = encryptStorage.getItem(USER)
    
    if(user)
    {
        if (user && user.isAdmin)
        {
            return true
        }else{
            return false
        }
    }else{
         return false
    }
}

Storage.getEmployeePIS = () => {

     const empPis = encryptStorage.getItem(EMPLOYEE_PIS)
     if(empPis)
     {
        return empPis
     }else{
         return null
     }
}

Storage.getRequiredFieldConfigs = () => {

    const requiredConf = encryptStorage.getItem(REQUIRED_FIELD_CONFIGS)

    if(requiredConf)
    {
        return requiredConf
    }else{
        return null;
    }
}

Storage.getControlConfigs = () => {
    const controlConf = encryptStorage.getItem(CONTROL_CONFIGS)

    if(controlConf)
    {
        return controlConf
    }else{
        return null;
    }
}

/// Set ////
Storage.setUser = (value) => {
    encryptStorage.setItem(USER, JSON.stringify(value))
}

Storage.setRole = (value) => {
    encryptStorage.setItem(ROLE, value)
}

Storage.setTenant = (value) => {
    encryptStorage.setItem(TENANT_EMPLOYEE, JSON.stringify(value))
}

Storage.getTenant = () => {
    
    const tanants = encryptStorage.getItem(TENANT_EMPLOYEE)

    if(tanants)
    {
        return tanants;
    }else{
        return null;
    }
}

Storage.setEmployeePIS = (value) => {
    encryptStorage.setItem(EMPLOYEE_PIS, JSON.stringify(value))
}

Storage.setRequiredFieldConfigs = (value) => {
    let dataTable = value.filter(c => c.required === true && c.tabControl !== null);
    let result = new Object();
    for (let i in dataTable) {

        let tableName = dataTable[i].tabControl;
        if (!result.hasOwnProperty(tableName)) {
            let dataType = dataTable.filter(c => c.tabControl === tableName)
            let resultTpye = new Object();
            for (let j in dataType) {
                let type = dataType[j].document_Type
                if (!resultTpye.hasOwnProperty(type)) {

                    let dataColumn = dataType.filter(c => c.document_Type === type)
                    let resultColumn = new Object();
                    for (let k in dataColumn) {
                        let columnName = dataColumn[k].dbTag_Id
                        if (!resultTpye.hasOwnProperty(type))
                            resultColumn[columnName] = dataColumn[k].tagDescription
                    }
                    resultTpye[type] = resultColumn
                }
            }

            result[tableName] = resultTpye

            if (tableName === 'T_GR_ITEM')
                result['T_GR_SERVICE'] = resultTpye
        }
    }
    encryptStorage.setItem(REQUIRED_FIELD_CONFIGS, JSON.stringify(result))
}

Storage.setControlConfigs = (value) => {
    encryptStorage.setItem(CONTROL_CONFIGS, JSON.stringify(value))
    Storage.setRequiredFieldConfigs(value)
}

Storage.setUserBussinessPlace = (unitCode, busPlace) => {

    let user = Storage.getUser()

    if (user) {
        user.unitCode = unitCode
        user.busPlace = busPlace
    }

    Storage.setUser(user)
}

Storage.setDatelocalStorage = () => {
    let getdate = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0)).format('YYYYMMDD')
    encryptStorage.setItem(DATE_LOCAL_STORAGE, getdate)
}

Storage.getDatelocalStorage = () => {

    const dateLocal = encryptStorage.getItem(DATE_LOCAL_STORAGE)

    if(dateLocal)
    {
        return dateLocal;
    }else{
        return null;
    }
}


Storage.setPostLogoutRedirectUri = (value) => {
    encryptStorage.setItem(POST_LOGOUT_REDIRECTURI, value)
}

Storage.getPostLogoutRedirectUri = () => {
    let result = encryptStorage.getItem(POST_LOGOUT_REDIRECTURI)
    return result
}

Storage.setShowLogin = (value) => {
    encryptStorage.setItem(SHOW_LOGIN, value)
}

Storage.getShowLogin = () => {
    let result = encryptStorage.getItem(SHOW_LOGIN)
    return result
}


Storage.setAppReadonly = (value) => {
    encryptStorage.setItem(APP_READONLY, value)
}

Storage.getAppReadonly = () => {
    let result = encryptStorage.getItem(APP_READONLY)
    return result
}

export default Storage


